  <div class="card shadow-sm border-0 w-100" >
    <form @submit.prevent="add_task">
    <div class="card-body">
    <div class="d-flex align-items-center mb-3">
        <input type="radio" class="form-check-input" />
        <!-- <p>{{members}}</p> -->
        <input
            type="text"
            v-model="task_name"
            class="form-control form-control-sm text-xxs border-0 border-bottom"
            placeholder="Enter a task name * (required)"
            @keydown.enter="submitTask"
        />
        </div>

        <div
            class="d-flex align-items-center mb-2 text-muted fs-xsm"
            @click="triggerDatePicker"
        >
        <i class="bi bi-calendar3 me-2"></i>
        <span class="small">
            {{ selectedDate ? formatDate(selectedDate) : "Set due date" }}
        </span>
        </div>
        <!-- Hidden date input -->
        <input
        ref="dateInput"
        type="date"
        class="d-none"
        v-model="selectedDate"
        @change="handleDateChange"
        />

        <!-- Trigger -->
<!-- Trigger -->
<div
  class="d-flex align-items-center text-muted fs-xsm"
  data-bs-toggle="dropdown"
>
   <template v-if="assignedMembers.length === 0">
    <i class="bi bi-person-plus"></i>
    <span class="small fw-500">Assign</span>
  </template>

  <div class="d-flex gap-1" v-else>
    <i class="bi bi-person-plus fs-6"></i>
    <div
      v-for="user in assignedMembers"
      :key="user.id"
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary align-items-center text-white py-2 w-20 h-20"
    >
      {{ getInitials(user.full_name) }}
    </div>
  </div>
</div>

<!-- Dropdown -->
<div class="dropdown-menu px-1 shadow border-0 assignment-dropdown"   data-bs-auto-close="outside">
  <input
    type="text"
    class="form-control form-control-sm text-xxs rounded-3 border-0 border-bottom mb-2"
    placeholder="Type a name or email address"
    v-model="searchQuery"
  />
  <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Suggestions</div>


  <div
    v-for="member in members"
    :key="member.id"
    class="d-flex align-items-center px-2 py-1 dropdown-item"
    @click="assignUser(member)"
  >
    <div
      class="rounded-circle d-flex justify-content-center align-items-center me-2 py-2 text-xxs text-white bg-primary w-20 h-20"
    >
      {{ getInitials(member.full_name) }}
    </div>
    <span class="text-dark small fs-xsm">{{member.full_name}}</span>
  </div>
</div>


    </div>

    <div class="card-footer bg-primary">
        <button class="btn btn-transparent w-100 btn-sm text-xxs text-white" type="submit">Add task</button>
    </div>
    </form>

  </div>